import { useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Container } from './Example';

const Board = ({ idAglomeration }: any) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <Container idAglomeration={idAglomeration} />
    </DndProvider>
  );
};

export default Board;
